import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '../api/types'

/** Não faz sentido re-tentar 4xx (validação, auth, not found). */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false
  return failureCount < 2
}

/** staleTime p/ listas de catálogo/opções (categorias, clientes, etc. em selects):
 *  mudam pouco e toda mutation invalida a key, então cache longo é seguro. */
export const CATALOG_STALE_TIME = 10 * 60_000

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Dados considerados frescos por 2 min (antes 30s) → menos re-fetch ao
      // revisitar telas; mutations invalidam a key, então edições atualizam.
      staleTime: 120_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
    },
    mutations: {
      retry: false,
    },
  },
})
